import {
  makeApiRequest,
  generateSymbol,
  parseFullSymbol,
  fnoTraderApiRequest,
  unixToDateString,
  transformData,
  resolutionsMap,
  getTokenBySymbol,
  transformMarkesData,
  getsearchAPI
} from "./helpers.js";

import { subscribeOnStream, unsubscribeFromStream } from "./streaming-Spot.js";

const lastBarsCache = new Map();

async function getTokenDetails(token) {
  const data = await fnoTraderApiRequest(`v2/instruments?tokens=${token}`);
  return data.data[0];
}
// DatafeedConfiguration implementation
const configurationData = {
  supported_resolutions: [ '1','2', '3', '4', '5', '10', '15','20', '30','75', '1H', '2H', '1D', '1W', '1M'],
  timezone: "Asia/Kolkata",
  session: "0915-1530",
  supports_timescale_marks:false,
  supports_marks:true
};



export default {
  onReady: (callback) => {
      setTimeout(() => callback(configurationData));
  },

  searchSymbols: async (
      userInput,
      exchange,
      symbolType,
      onResultReadyCallback
    ) => {
      console.log('[onReady]: Method call');

      try {
        // const { data } = await fnoTraderApiRequest(
        //   `ov5/search?query=${userInput}`
        // );
        const values  = await getsearchAPI(userInput);
        // console.log("resFuture", resFuture)
        // const { values = [] } = data;
        
        const dt = values.data.values.map((value) => ({
          symbol: value.symbol,
          full_name: value.displayName,
          description: value.displayName,
          exchange: value.exchange,
          ticker: value.symbol,
        }));
  
        onResultReadyCallback(dt);
      } catch (err) {
        onResultReadyCallback([]);
      }
  },

  resolveSymbol: async (
      symbolName,
      onSymbolResolvedCallback,
      onResolveErrorCallback,
      extension
  ) => {

      try {
  
       
          const token = await getTokenBySymbol(symbolName);

        


          const instrumentData = await getTokenDetails(token);

    
          const symbolInfo = {
            ticker: symbolName, // ticker is an internal field, this is not shown to the users.
            name: instrumentData.tradingSymbol,
            description: instrumentData.displayName,
            type: instrumentData.instrumentType,
            session: configurationData.session,
            timezone: configurationData.timezone,
            exchange: instrumentData.exchange,
            minmov:
              instrumentData.segment === "INDICES"
                ? 5
                : instrumentData.tickSize * 100,
            pricescale: 100,
            has_intraday: true,
            data_status:"streaming",
           // delay:180,
            has_no_volume: false,
            visible_plots_set: "ohlcv",
            has_weekly_and_monthly: false,
            supported_resolutions: configurationData.supported_resolutions,
            supports_marks:configurationData.supports_marks,    
          //  supports_timescale_marks: configurationData.supports_timescale_marks,
            volume_precision: 2,
            data_status: "streaming",
            sector: instrumentData.sector,
          };
    
          onSymbolResolvedCallback(symbolInfo);
        } catch (err) {
          console.log("err", err);

          onResolveErrorCallback(err);
        }

       

   },

  getBars: async (symbolInfo, resolution, periodParams, onHistoryCallback, onErrorCallback) => {

      const token = await getTokenBySymbol(symbolInfo.ticker);

      
      const { from, to, firstDataRequest } = periodParams;
      const urlParameters = {
          tokens: token,
          type: resolutionsMap[resolution],
          from: unixToDateString(from).split("T")[0]+"T09:15",
          to: unixToDateString(to)
        };
        const query = Object.keys(urlParameters)
          .map((name) => `${name}=${encodeURIComponent(urlParameters[name])}`)
          .join("&");

        



      try {
          const data = await fnoTraderApiRequest(`v6/pattern?${query}`);;
          if (!data?.data || !data.data[token]) {
              // "noData" should be set if there is no data in the requested period
              onHistoryCallback([], { noData: true });
              return;
          }
          const isCustomIndicator = symbolInfo.ticker.includes("#");
          let whichCustomIndicator = "";
          if (isCustomIndicator) {
            whichCustomIndicator = symbolInfo.ticker.split("#")[1];
          }

          const bars = transformData(data.data[token], whichCustomIndicator, resolution);
          if (firstDataRequest && !isCustomIndicator) {
            lastBarsCache.set(token, { ...bars[bars.length - 1] });
          } else if (firstDataRequest && isCustomIndicator) {
            lastBarsCache.set(symbolInfo.ticker, { ...bars[bars.length - 1] });
          }

          onHistoryCallback([...bars], { noData: false });
      } catch (error) {
          console.log('[getBars]: Get error', error);
          onErrorCallback(error);
      }
  },

  subscribeBars: async (symbolInfo, resolution, onRealtimeCallback, subscriberUID, onResetCacheNeededCallback) => {
    const token = await getTokenBySymbol(symbolInfo.ticker);
    if (symbolInfo.ticker.includes("#")) {
      subscribeOnStream(
        symbolInfo,
        resolution,
        onRealtimeCallback,
        subscriberUID,
        onResetCacheNeededCallback,
        lastBarsCache.get(symbolInfo.ticker)
      );
      return;
    }
    subscribeOnStream(
      symbolInfo,
      resolution,
      onRealtimeCallback,
      subscriberUID,
      onResetCacheNeededCallback,
      lastBarsCache.get(token)
    );
  },
  unsubscribeBars: (subscriberUID) => {
      console.log('[unsubscribeBars]: Method call with subscriberUID:', subscriberUID);
      unsubscribeFromStream(subscriberUID);
  },
};

